import styled from 'styled-components'
import {
  fontSizes,
  palette,
  fontFamily,
  fontWeight,
} from '../../design/StyleGuide/StyleGuide'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${palette.border};
`

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 1126px;
  margin: 0px auto;
  padding: 0;

  @media screen and (max-width: 1380px) {
    margin-left: 122px;
    padding-right: 122px;
  }

  @media screen and (max-width: 1170px) {
    margin-left: 44px;
    padding-right: 44px;
  }

  @media screen and (max-width: 767px) {
    margin-left: 22px;
    padding-right: 22px;
  }
`

export const FooterSection = styled.div`
  padding-top: 60px;
  padding-bottom: 60px;
  display: flex;
  flex-wrap: wrap;
  background-color: ${palette.border};

  @media screen and (max-width: 760px) {
    padding-top: 40px;
  }
`

export const FooterLinks = styled.ul`
  padding-left: 20px;
  padding-right: 20px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  text-align: left;
  list-style: none;
  line-height: 1.78;
  color: #d8d8d8;
  height: fit-content;

  flex: 10%;
  /* TODO: flex: 1; */
  @media screen and (max-width: 768px) {
    flex: 50%;
    padding-left: 0;
    padding-right: 0;
  }

  @media screen and (max-width: 320px) {
    flex: 50%;
  }
`

export const FooterLinksSocial = styled.ul`
  padding-left: 20px;
  flex: 10%;
  /* FIXME: Use var */
  height: 600px;
  height: fit-content;
  text-align: left;
  list-style: none;
  line-height: 1.78;
  color: #d8d8d8;

  @media screen and (max-width: 760px) {
    order: 5;
    flex: none;
    padding-top: 80px;
    margin: 10px auto;
  }
`

export const FooterLinkItem = styled.li`
  font-family: ${fontFamily.base};
  font-weight: ${fontWeight.bold};
  font-style: normal;
  font-size: 16px;
  font-stretch: normal;
  letter-spacing: normal;
`

export const BusinessToolsLinkItem = styled.li`
  font-family: ${fontFamily.base};
  font-size: ${fontSizes.base};
  font-weight: ${fontWeight.base};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: normal;
  color: ${palette.neutral};
`

export const ConnectLinkItem = styled.li`
  font-family: ${fontFamily.base};
  font-size: ${fontSizes.base};
  font-weight: ${fontWeight.base};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: normal;
  color: ${palette.actionInverse};
  @media screen and (max-width: 320px) {
    width: 171px;
    font-family: ${fontFamily.base};
    font-size: 14px;
    font-weight: ${fontWeight.base};
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
  }
`

export const SocialMediaLinkItem = styled.li`
  display: inline;
  width: 16px;
  height: 16px;
  padding-right: 16px;
`

export const SocialMediaIcon = styled.img`
  display: inline;
  width: 16px;
  height: 16px;
`

export const LinkHeader = styled.p`
  color: #d8d8d8;
  margin: 0;
  padding: 0;
`

export const FooterLink = styled.a`
  text-decoration: none;
  color: ${props => (props.linkColor ? props.linkColor : `#d8d8d8`)};
  &:hover {
    color: ${palette.action};
  }
`



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Footer/styled.js